var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circlesrenderercanvas"},[_c('canvas',{ref:"circles"}),_c('canvas',{ref:"dashes",staticClass:"dashes"})])}
var staticRenderFns = []

export { render, staticRenderFns }